import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import {
  HeroSection,
  FeaturesSection,
  StepsSection,
  StatsSection,
  CTASection,
  LandingFooter,
  LandingNavbar,
  BackgroundEffects,
  SonarAnimation
} from '@/components/landing';

const LandingPage = () => {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div className="min-h-screen landing-gradient-bg relative overflow-x-hidden">
      {/* Animated background */}
      <SonarAnimation />
      
      {/* Glow effects */}
      <BackgroundEffects />
      
      {/* Content */}
      <div className="relative z-10">
        <LandingNavbar />
        <HeroSection />
        <FeaturesSection />
        <StepsSection />
        <StatsSection />
        <CTASection />
        <LandingFooter />
      </div>
    </div>
  );
};

export default LandingPage;
